import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { GlobalService } from 'app/global/global.service';
import { SessionImageService } from 'app/global/session-image.service';

@Injectable({
    providedIn: 'root'
})

export class ContentBoxSettingsService {

    private renderer: Renderer2;
    constructor(
        private globalService: GlobalService,
        private rendererFactory: RendererFactory2,
        private sessionImageService: SessionImageService
    ) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    setContentBoxImage(uuid: string, image: string, force: boolean = false, bgImage:string = '') {
        const editorElement = document.querySelector(`.editor${uuid}`);
        if (editorElement) {
            const parentElement = this.renderer.parentNode(editorElement).closest('.content-editor-block');
            if (!parentElement.classList.contains('has-background-image') || force) {
                this.renderer.addClass(parentElement, 'has-background-image');
                this.renderer.setProperty(parentElement, 'style', `--content-background-image: url(${bgImage})`);
            }
        }
        this.globalService.updateBlock(uuid, { background_image: image });
    }

    removeContentBoxIamge(uuid:string|number){
        const editorElement = document.querySelector(`.editor${uuid}`);
        if (editorElement) {
        const parentElement = this.renderer.parentNode(editorElement).closest('.content-editor-block');
        this.renderer.removeClass(parentElement, 'has-background-image');
        this.renderer.setProperty(parentElement, 'style', `--content-background-image: ''`);
        }
        this.globalService.updateBlock(uuid, { background_image: ''});
    }
}